import { TextMaterialCategory } from '@@types'
import { gql, useQuery } from '@apollo/client'

export type TextMaterialCategoryQuery = {
  textMaterialCategories: TextMaterialCategory[]
}

export const GQL_QUERY_TEXT_MATERIAL_CATEGORIES = gql`
  query textMaterialCategories {
    textMaterialCategories {
      id
      title
      slug
    }
  }
`

export default function useFetchTextMaterialCategories () {
  const { data, loading, error } = useQuery<TextMaterialCategoryQuery>(GQL_QUERY_TEXT_MATERIAL_CATEGORIES)

  const textMaterialCategories = data?.textMaterialCategories ?? []

  return {
    textMaterialCategories,
    data,
    loading,
    error,
  }
}
